var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M13 8L13 11L3 11L3 13L13 13L13 16L17 12L13 8ZM21 4L19 4L19 20L21 20L21 4Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
